export const errorType = {
    UNAUTHORIZED: {
        message: 'Authentication is needed to get requested response.',
        statusCode: 401
    },
    UNAUTHORIZED_READ: {
        message: 'Usuario no esta autorizado para leer',
        statusCode: 401
    },
    UNAUTHORIZED_CREATE: {
        message: 'Usuario no esta autorizado para insertar',
        statusCode: 401
    },
    UNAUTHORIZED_UPDATE: {
        message: 'Usuario no esta autorizado para actualizar',
        statusCode: 401
    },
    UNAUTHORIZED_DELETE: {
        message: 'Usuario no esta autorizado para eliminar.',
        statusCode: 401
    },
    INVALID_EMAIL: {
        message: 'The email is not valid',
        statusCode: 400
    },
    DB_ERROR: {
        message: 'Database error',
        statusCode: 400
    }
};
/**
 * Funcion que devuelve un objeto con el codigo y el mensaje 
 * @param {*} errorName - Nombre del error a validar y sacar su codigo
 * @returns Objeto con el mensaje y codigo correspondiente
 */
export const getErrorCode = (errorName) => {   
    let error = {
        message: "internal error",
        statusCode: "400"
    };
    if(errorName != ''  ){        
        let auxError  = errorType[errorName];
        if(auxError != undefined && auxError != null){
            error.message = auxError.message;
            error.statusCode = auxError.statusCode;
        }
        else
            error.message = errorName;        
    }      
    return error;
};
/*
module.exports = {
    errorName,
    errorType,
    getErrorCode
}
*/